import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import "react-phone-input-2/lib/style.css";
import TimeInput from "react-time-picker-input";
import moment from "moment";
import Loader from "../utils/Loader";

function EditHorario({ history, match }) {
  const dispatch = useDispatch();
  const modelHorarioById = useSelector((state) => state.horarioById);
  const modelEditHorario = useSelector((state) => state.editHorario);

  const [profesional, setProfesional] = useState(null);
  const [dia, setDia] = useState(1);
  const [duracion, setDuracion] = useState(null);
  const [localId, setLocalId] = useState(null);
  const [servicioSelected, setServicioSelected] = useState(null);
  const [inicio, setInicio] = useState("07:00");
  const [fin, setFin] = useState("21:00");

  useEffect(() => {
    const data = modelHorarioById?.data?.data?.data;
    const error = modelHorarioById?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckHorarioById.actions.clear());
    }
    if (data) {
      setDia(data.numeroDia);
      setDuracion(data.duracion);
      setProfesional(data.extraKey.profesionalId);
      setInicio(data.inicio);
      setFin(data.fin);
      setLocalId(data.localId);
      setServicioSelected(data.foreingKey);
      dispatch(controller.duckHorarioById.actions.clear());
    }
  }, [modelHorarioById]);

  useEffect(() => {
    dispatch(controller.horarioByIdThunk(match.params.id));
    //dispatch(controller.opcionesServiciosByProfesionalThunk(match.params.profesionalId))
  }, []);

  useEffect(() => {
    const data = modelEditHorario?.data?.data;
    const error = modelEditHorario?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckEditHorario.actions.clear());
    }
    if (data) {
      history.push(`/horariosList/${localId}`);
      dispatch(controller.duckEditHorario.actions.clear());
    }
  }, [modelEditHorario]);

  function submit() {
    if (
      dia < 0 ||
      dia > 6 ||
      !inicio ||
      !fin ||
      !servicioSelected ||
      !profesional ||
      !localId
    ) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (
      moment(inicio, "HH:mm").format("HH:mm") >=
      moment(fin, "HH:mm").format("HH:mm")
    ) {
      alert("El horario de inicio debe ser menor al horario final");
      return;
    }
    let data = {
      _id: match.params.id,
      id: match.params.id,
      dia,
      duracion,
      inicio,
      fin,
      servicioId: servicioSelected,
      profesionalId: profesional,
      localId,
    };

    dispatch(controller.editarHorarioThunk(data));
  }

  return (
    <Content title="Editar horario" browserTitle="Editar horario" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Editar horario"
            footer={
              <>
                {" "}
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.goBack();
                  }}
                />
                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelEditHorario.loading}
                    >
                      Guardar
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelEditHorario.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <Col md="12">
              {" "}
              <text>
                <strong>Desde</strong>
              </text>
              <TimeInput value={inicio} onChange={setInicio} />
              <text>
                <strong>Hasta</strong>
              </text>
              <TimeInput value={fin} onChange={setFin} />
            </Col>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default EditHorario;
